import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const EventDiaTalk = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_diatalk)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833333 11C0.833333 8.6988 2.69881 6.83333 5 6.83333C7.3012 6.83333 9.16667 8.6988 9.16667 11C9.16667 13.3012 7.3012 15.1667 5 15.1667C4.3096 15.1667 3.65724 14.9984 3.08293 14.7003L1.60819 14.9749C1.44615 15.0051 1.27966 14.9534 1.16311 14.8369C1.04657 14.7203 0.994947 14.5539 1.02511 14.3918L1.29969 12.9171C1.00163 12.3427 0.833333 11.6904 0.833333 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1666 6.66667C15.1666 3.44501 12.555 0.833333 9.33327 0.833333C6.48961 0.833333 3.93465 2.99953 3.55839 5.8392C3.55806 5.84039 3.55779 5.84122 3.55759 5.84175C3.55827 5.83239 3.55775 5.83372 3.55731 5.83673C3.55688 5.83974 3.55654 5.84443 3.55759 5.84175C3.55707 5.84871 3.5559 5.86154 3.55353 5.88394C3.55085 5.91034 3.54732 5.9479 3.54353 5.9955C3.54236 6.01022 3.54116 6.0259 3.53996 6.04252C4.00295 5.90638 4.49296 5.83333 5.00003 5.83333C7.85353 5.83333 10.1667 8.14653 10.1667 11C10.1667 11.5061 10.0939 11.9951 9.95833 12.4573C10.0109 12.4532 10.0573 12.4491 10.0969 12.4452C10.1458 12.4405 10.1843 12.4361 10.2114 12.4329L10.2433 12.4289L10.2526 12.4277L10.2555 12.4273L10.2565 12.4272L10.2573 12.4271L10.2677 12.4255C10.9157 12.3211 11.5279 12.11 12.0857 11.811L14.3085 12.2249C14.4705 12.2551 14.637 12.2034 14.7535 12.0869C14.8701 11.9703 14.9217 11.8039 14.8915 11.6418L14.4777 9.419C14.9174 8.59873 15.1666 7.66113 15.1666 6.66667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_diatalk">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EventDiaTalk;
